import initDatepicker from "./init-datepicker";
import initDropDownsPrograms from "./dropDownPrograms";
import netRequests from "./netRequests";
import selects from "./selects";
import send from "./send";
import monitoring from "../monitoring";
import formMetrix from "./form-metrix";
import getPageName from "../getPageName";
import { setupProgramFieldHint } from "./programFieldHint";
import { setupTariffPreselect } from "./tariffPreselect";

const form = () => {
  /* Получение списка доступных программ для редиректа и передача в инициализацию поля "Программа обучения" */
  async function initNetRequests() {
    const allPrograms = await netRequests();

    initRegions(allPrograms);
    initDropDownsPrograms(allPrograms.programs);
    send();
    monitoring(allPrograms);
  }

  initDatepicker();
  selects();
  setupProgramFieldHint();
  setupTariffPreselect();
  initNetRequests();
  formMetrix();

  function initRegions(allPrograms) {
    try {
      const data = [...allPrograms.regions];

      // Регион с id 90 всегда показывается последним в списке (бизнес-правило)
      const targetRegionIndex = data.findIndex((region) => region.id == 90);

      if (targetRegionIndex !== -1) {
        const [targetRegion] = data.splice(targetRegionIndex, 1);
        data.push(targetRegion);
      }

      // На странице конкретной программы регион можно выбрать только из тех,
      // что реально доступны у этой программы. На главной регионов не фильтруем.
      const pageProgram = allPrograms.programs.find(
        (program) => program.shortname === getPageName(),
      );

      const availableRegions = pageProgram
        ? data.filter((region) =>
            pageProgram.regions?.some(
              (programRegion) => programRegion.region_id == region.id,
            ),
          )
        : data;

      function addRegionsSelect(id) {
        let regionsSelect = $(id);

        availableRegions.forEach(function (el) {
          let selected = false,
            option = new Option(el.name, el.id, false, selected);

          option.accessKey = el.id;
          regionsSelect.append(option);
        });

        regionsSelect.val(null);
        regionsSelect.select2({
          placeholder: "Ваш регион",
        });
      }

      addRegionsSelect("#Regions");
      addRegionsSelect("#Regions-program");
    } catch (e) {
      console.log(e);
    }
  }
};

export default form;
